<template>
  <BranchDetailTabs :config="config" />
</template>

<script>
import BranchDetailTabs from "../../components/BranchDetailTabs/BranchDetailTabs.vue";

export default {
  name: "app",
  components: {
    BranchDetailTabs
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
